module.exports = __webpack_public_path__ + "img/0-22.5223323c.jpg";